import { InlineMessage } from '@strata/react-inline-message';
import PropTypes from 'prop-types';

import { BulkUploadValidationErrorsDialog } from 'components/dialogs/BulkUploadValidationErrorsDialog';
import { ValidationErrorsPropType } from 'pages/productConfig/ProductPayerConfigBulkUploadSupport';

export const ProductPayerConfigBulkUploadErrorsDialog = ({
    validationErrors = undefined,
    showDialog,
    onCloseDialog,
}) => (
    <BulkUploadValidationErrorsDialog
        uploadName="Product Payer Config"
        isOpen={showDialog}
        onClose={onCloseDialog}
        validationErrors={validationErrors}
    />
);

export const ProductPayerConfigBulkUploadErrorMessage = ({
    validationErrors = undefined,
    onOpenDialog,
}) =>
    validationErrors ? (
        <InlineMessage
            intent={InlineMessage.Intent.ERROR}
            wrapText
            label={
                <>
                    <span>An error occurred while uploading the product payer config file.</span>
                    <br />
                    <span>Please fix the errors in the uploaded file.&nbsp;</span>
                    <u
                        style={{ cursor: 'pointer' }}
                        role="button"
                        tabIndex={0}
                        onClick={onOpenDialog}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                onOpenDialog();
                            }
                        }}
                    >
                        View Details
                    </u>
                </>
            }
        />
    ) : null;

ProductPayerConfigBulkUploadErrorsDialog.propTypes = {
    validationErrors: ValidationErrorsPropType,
    showDialog: PropTypes.bool.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
};

ProductPayerConfigBulkUploadErrorMessage.propTypes = {
    validationErrors: ValidationErrorsPropType,
    onOpenDialog: PropTypes.func.isRequired,
};
